import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (n) => `${(n || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const PERIODS = [['today', 'Hoy'], ['week', 'Esta semana'], ['month', 'Este mes']];

export const SalesSummary = ({ refreshKey }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/sales-summary`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [refreshKey]);

  if (!data) return null;

  return (
    <div className="mb-8" data-testid="sales-summary">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {PERIODS.map(([key, label]) => {
          const p = data[key];
          return (
            <div key={key} className="bg-black text-white rounded-xl p-5" data-testid={`sales-${key}`}>
              <p className="text-[11px] tracking-[0.25em] uppercase text-white/60">{label}</p>
              <p className="text-3xl font-bold mt-2" data-testid={`sales-${key}-net`}>{eur(p.net)}</p>
              <p className="text-xs text-white/60 mt-1">te queda tras comisiones</p>
              <div className="mt-4 pt-3 border-t border-white/15 text-xs space-y-1 text-white/80">
                <div className="flex justify-between"><span>Vendido ({p.orders} {p.orders === 1 ? 'pedido' : 'pedidos'})</span><span data-testid={`sales-${key}-gross`}>{eur(p.gross)}</span></div>
                <div className="flex justify-between"><span>Comisiones Stripe</span><span data-testid={`sales-${key}-fees`}>− {eur(p.fees)}</span></div>
              </div>
            </div>
          );
        })}
      </div>
      {!data.fees_available && (
        <p className="text-xs text-amber-600 mt-2" data-testid="sales-fees-warning">No se pudieron leer las comisiones de Stripe ahora mismo.</p>
      )}
    </div>
  );
};
